import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import pkg from '../package.json'

Vue.use(Router)

const { endpoint } = pkg.config

import highlights from './views/Highlights.vue'
import explore from './views/Explore.vue'
import media from './views/Media.vue'
import cookieNotice from './views/CookieNotice.vue'

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/cookie-notice',
    component: cookieNotice
  },
  {
    path: '/',
    redirect: '/welcome',
    meta: {
      highlights: true
    }
  },
  {
    path: '/explore',
    component: explore,
    meta: {
      sidebar: true,
      sidebarOuter: true,
      explore: true
    }
  },
  {
    path: '/explore/:tour_id',
    redirect: '/explore'
  },
  {
    path: '/explore/:tour_id/:pano_id',
    component: explore,
    meta: {
      sidebar: true,
      sidebarInner: true,
      explore: true
    },
    children: [
      {
        path: ':media_id',
        component: media
      }
    ]
  },
  {
    path: '/:highlight_id',
    component: highlights,
    meta: {
      reposition: true,
      highlights: true
    },
    children: [
      {
        path: ':media_id',
        component: media
      }
    ]
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (!store.state.posts.length) {
    Promise.all([
      fetch(`${endpoint}/rv/v1/basis?per_page=-1`)
        .then(res => res.json())
    ])
      .then(([res]) => {
        store.commit({
          type: 'populate',
          posts: res,
          error: null
        })
        store.commit('route', to)
        next()
        store.commit('isLoading', false)
      })
      .catch((err) => {
        store.commit({
          type: 'populate',
          error: err
        })
      })
  } else {
    store.commit('isLoading', true)
    next()
    store.commit('route', to)
    store.commit('isLoading', false)
  }
})

export default router
